import React from 'react'
import PropTypes from 'prop-types'

import ADACheckbox from 'components/_new/ada/ADACheckbox/ADACheckbox'
import ProductImage from 'components/_new/ui/ProductImage/ProductImage'
import SelectableBoxView from 'components/_new/ui/SelectableBoxView/SelectableBoxView'
import ProductCardBase from 'components/_new/productCard/ProductCardBase/ProductCardBase'

import s from './SelectableProductCard.scss'


const SelectableProductCard = (props) => {
  const {
    brand, name, image, upchargePrice, rating, active, withGender,
    isFetching, nameTextProps, brandTextProps, sex, onClick,
  } = props

  const icon      = active ? 'checkmark' : 'plus'
  const iconColor = active ? 'brand' : 'black'

  return (
    <ADACheckbox
      className={s.selectableProductCard}
      isChecked={active}
      ariaLabel={`${brand}. ${name}`}
      dataTestId="selectableProductCard"
      onClick={onClick}
    >
      {
        React.createElement(ProductCardBase, {
          className: s.selectableProductCard,
          sex,
          name,
          brand,
          image,
          rating,
          withGender,
          upchargePrice,
          nameTextProps,
          brandTextProps,
          imageNode: (
            <SelectableBoxView
              icon={icon}
              active={active}
              isFetching={isFetching}
              iconColor={iconColor}
              tag="div"
              fullWidth
            >
              <ProductImage src={image} />
            </SelectableBoxView>
          ),
        })
      }
    </ADACheckbox>
  )
}

SelectableProductCard.propTypes = {
  ...ProductCardBase.propTypes,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
}

SelectableProductCard.defaultProps = {
  active: false,
}


export default SelectableProductCard
